import domWrap from "../utils/domWrap";

export default async container => { // 'footer-actions'

	let buttons = container.querySelector('.buttons'),
		trigger = 0,
		triggerTop = 0,
		fixed = false,
		hidden = true;

	window.addEventListener('resize', findTrigger);
	window.addEventListener('scroll', scrollCheck);
	findTrigger();
	scrollCheck();

	function findTrigger() {
		const containerHeight = getOffset(container).top;
		trigger = containerHeight + ((container.offsetHeight / 2) + (buttons.offsetHeight / 2)) - window.innerHeight;
	}

	function scrollCheck(e) {
		var scrollTop = window.scrollY,
			makeFixed = scrollTop < trigger,
			makeHidden = scrollTop < triggerTop;

		if (makeFixed !== fixed) {
			fixed = makeFixed;
			buttons.classList.toggle('fixed', fixed);
		}

		if (makeHidden !== hidden) {
			hidden = makeHidden;
			buttons.classList.toggle('visible', !hidden);
		}
	}

	function getOffset(e) {		
		let x = 0;
		let y = 0;

		while (e && !isNaN(e.offsetLeft) && !isNaN(e.offsetTop)) {
			x += e.offsetLeft - e.scrollLeft;
			y += e.offsetTop - e.scrollTop;
			e = e.offsetParent;
		}

		return { top: y, left: x };
	}

};